<template>
    <div>
        <div class="box">
            <div>
                <h1>服务分包管理系统</h1>
            </div>
            <div class="right">
                <p style="padding-right: 100px;">
                    
                    <el-popover
                        placement="bottom"
                        width="400"
                        trigger="click">
                        <div v-for="(item,key) in gridData" :key="item.name" 
                            style="height: 200px;overflow:auto;">
                            <div>
                                您有新的任务待处理,请及时前往查看 
                                日期:{{ item.CreateTime.split('T')[0] }}
                                处理人:{{ item.UserName }}
                                <a @click="look(item.PathUrl,item)" style="color: blue;cursor: pointer;">前往查看</a>
                            </div>
                        </div>
                        <div v-if="gridData.length == 0">
                            暂无消息
                        </div>
                        <el-badge :value="InfoCount" :max="99" class="item" slot="reference">
                            <i class="el-icon-bell" style="font-size: 20px;"></i>
                        </el-badge>
                        </el-popover>
                </p>
                <p>欢迎您:{{user.userName}} ||</p>
                <p>角色:{{user.role == 0 ? '系统管理员':user.role == 1 ?'站点管理员':user.role == 2 ?'委托用户':user.role ==3? '操作员':'报告员'}} || </p>
                <p @click="loginOut">退出</p>
            </div>
        </div>
        <div>

        </div>
    </div>
        
</template>
<script>
import {GetUser} from '@/api/login'
import {GetEntrustInfoList,UpdateByID} from '@/api/entrustInfo'
export default{
    name:'header-top',
    data(){
        return{
            user:{},
            gridData: [],
            InfoCount:1
        }
    },
    methods:{
        loginOut(){
            this.$router.push({path:'/login'});
            window.localStorage.clear();
        },
        look(e,f){
            console.log(e)
            var param = {
                ID:f.ID
            }
            UpdateByID(param).then(res=>{

            })
            this.GetEntrustInfoList()
            this.$router.push({path:e})

        },
        GetEntrustInfoList(){
            var param = {
                where:'1=1 and HandleStatus=0'
            }
            GetEntrustInfoList(param).then(res=>{
                console.log(res.data)
                if(res.status == 200){
                    this.gridData = res.data.Data
                    this.InfoCount = res.data.Count
                }
            })
        }
    },
    mounted(){
        this.GetEntrustInfoList()
    },
    created(){
        var token = window.localStorage.getItem('token');
        GetUser(token).then(res=>{
            console.log(res)
            if(res.status == 200){
                this.user = res.data
                console.log(this.user)
            }
        })

    }
}
</script>
<style scoped>
.box{
    height: 50px;
    display: flex;
    justify-content: space-between;
    padding: 0 100px;
    align-items: center;
    font-size: 14px;
    background: #3c8dbc;
    color: white;
}
.right{
    display: flex;
}
.right>p:nth-child(3){
    cursor: pointer;
}
</style>